import * as Yup from "yup";
import { STATUS_OPTIONS_PRIVATE } from "../constants/status";

export const agreementSchema = Yup.object().shape({
  order_number: Yup.string().required("Ingrese el nº de resolución").trim().max(10, "No puede tener más de 10 caracteres"),
  agreement_type: Yup.string()
    .oneOf(["Marco", "Específico", "Adenda o Anexo"])
    .required("Seleccione el tipo de convenio"),
  objective: Yup.string("Debe ser una cadena de caracteres")
    .min(1, "No puede tener menos de 1 caracter")
    .max(1000, "No puede tener más de 1000 caracteres")
    .required("Ingrese el objetivo"),
  entity: Yup.string("Debe ser una cadena de caracteres")
    .min(1, "No puede tener menos de 1 caracter")
    .max(255, "No puede tener más de 255 caracteres")
    .required("Ingrese el nombre de la Institución"),
  resolution_number: Yup.string()
    .required("Ingrese el nº de resolución")
    .max(20, "No puede tener más de 20 caracteres")
    .trim(),
  suscription_date: Yup.date().nullable().typeError("La fecha debe ser válida"),
  effective_date: Yup.date().required("Ingrese la fecha de vigencia"),
  signers: Yup.array()
  .of(
    Yup.object().shape({
      name: Yup.string()
        .required("Ingrese el nombre del firmante")
        .min(1, "No puede tener menos de un caracter")
        .max(50, "No puede tener más de 50 caracteres"),
      position: Yup.string()
        .required("Ingrese el cargo del firmante")
        .min(1, "No puede tener menos de un caracter")
        .max(50, "No puede tener más de 50 caracteres"),
    })
  )
  .min(1, "Debe contener al menos un firmante")
  .max(10, "No puede tener más de 10 firmantes"),
  files: Yup.array()
  .min(1, "Debe adjuntar al menos un archivo")
  .max(10, "No puede tener más de 10 archivos adjuntos")
  .of(
    Yup.mixed().test(
      "fileFormat",
      "Solo se permiten archivos PDF, JPG o PNG",
      (value) => {
        // Permitir archivos vacíos (en caso de eliminar)
        if (!value) return false;
        // Si no tiene type, asumimos que es un archivo existente válido
        if (!value.type) return true;
        // Validar tipo solo para archivos nuevos
        return ["application/pdf", "image/jpeg", "image/png"].includes(value.type);
      }
    )
  ),
  proponent_email: Yup.string()
    .email("Debe ser un correo electrónico válido")
    .required("El correo del proponente es obligatorio"),  
  notification_amount: Yup.number()
    .required("La cantidad es obligatoria")
    .integer("Debe ser un número entero")
    .positive("Debe ser mayor que cero"),
  notification_unit: Yup.string()
    .required("La unidad es obligatoria")
    .oneOf(["days", "weeks", "months"], "Unidad inválida")

});

export const analysisSchema = Yup.object().shape({
  evaluated_period: Yup.string("Debe ser una cadena de caracteres").required(
    "Ingrese el periodo evaluado"
  ),
  evaluation_unit: Yup.string("Debe ser una cadena de caracteres").required(
    "Ingrese la unidad evaluadora"
  ),
  academic_unit: Yup.string("Debe ser una cadena de caracteres").required(
    "Ingrese la unidad académica"
  ),
  career: Yup.string("Debe ser una cadena de caracteres").required(
    "Ingrese la carrera"
  ),
  coordinators: Yup.array().of(
    Yup.object().shape({
      name: Yup.string("Debe ser una cadena de caracteres")
        .required("Ingrese el nombre del coordinador")
        .min(1, "No puede tener menos de un caracter")
        .max(255, "No puede tener más de 255 caracteres"),
    })
  ),
  proposal: Yup.string("Debe ser una cadena de caracteres").required(
    "Ingrese la propuesta"
  ),
  presentation_date: Yup.date().required("Ingrese la fecha de presentación"),
  observation: Yup.string("Debe ser una cadena de caracteres").required(
    "Ingrese una observación"
  ),
});

export const agreementEditSchema = agreementSchema.concat(analysisSchema);
